import script from "./button-v2.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./button-v2.vue?vue&type=script&setup=true&lang=ts"
export * from "./button-v2.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./button-v2.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__